import { IsEnum } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { ActivityVisibility } from '../../../enums'

export class SetVisibilityDto {
  @ApiPropertyOptional({
    description: 'Nouvelle visibilité',
    enum: ActivityVisibility,
  })
  @IsEnum(ActivityVisibility)
  newVisibility!: ActivityVisibility
}
